<template>
  <div class="scheduler-container">
    <div class="scheduler-header">
      <div class="scheduler-header-left">
        <div class="scheduler-year">
          <span>
            <img
              id="leftArrow"
              alt="leftArrow"
              src="../../assets/arrowLeft.svg"
              v-on:click.self="changeYear(-1)"
            />
          </span>
          <span>{{ year }}</span>
          <span>
            <img
              id="rightArrow"
              alt="rightArrow"
              src="../../assets/arrowRight.svg"
              v-on:click.self="changeYear(1)"
            />
          </span>
        </div>
        <div class="scheduler-months">
          <span
            class="scheduler-month"
            :class="{ monthSelected: selMonth == month }"
            v-for="(month, index) of months"
            :key="month + index"
            v-on:click.self="changeMonth(index)"
            >{{ month }}</span
          >
        </div>
      </div>
      <div class="scheduler-header-right">
        <div class="scheduler-year-small-device" v-if="smallDevice">
          <span>
            <img
              id="leftArrow"
              alt="leftArrow"
              src="../../assets/arrowLeft.svg"
              v-on:click.self="changeYear(-1)"
            />
          </span>
          <span>{{ year }}</span>
          <span>
            <img
              id="rightArrow"
              alt="rightArrow"
              src="../../assets/arrowRight.svg"
              v-on:click.self="changeYear(1)"
            />
          </span>
        </div>
        <slot name="actions" />
      </div>
    </div>
    <div class="scheduler-body-wrapper">
      <div
        class="scheduler-body"
        :style="styleSchedulerBody()"
        ref="schedulerBody"
      >
        <div class="scheduler-column-title">{{ columnTitle }}</div>
        <div
          class="scheduler-day-title"
          v-for="day of days"
          :key="day.keyIndex"
        >
          <span>{{ day.ofMonth }}</span>
          <span>{{ day.ofWeek }}</span>
        </div>
        <div
          class="scheduler-row-title"
          v-for="(element, index) of rows"
          :key="element.row.id"
          :style="index + 1 === rows.length ? lastBorder() : ''"
          :class="{ 'scheduler-row-special-title': element.row.special }"
        >
          <div
            class="scheduler-row-special-title-subcontainer"
            v-if="element.row.special"
          >
            <img
              @click="toggleEvents(element.row)"
              src="@/assets/plus-grey.svg"
              v-if="element.toggled"
            />
            <img
              @click="toggleEvents(element.row)"
              src="@/assets/minus-grey.svg"
              v-else
            />
            <a :href="element.propertyUrl" :title="element.row.name">{{
              element.row.name
            }}</a>
          </div>
          <span
            v-else
            class="scheduler-row-room-details"
            @click="getRoomId(element.row.room)"
            >Room {{ element.row.name }}</span
          >
        </div>
        <room-detail :roomId="selRoom ? selRoom : ''" />

        <div
          class="scheduler-event-container"
          v-for="event of visibleEvents"
          :data-id="event.id"
          :key="event.id"
          :style="[
            event.text === 'fake'
              ? { display: 'none' }
              : { overflow: 'visible' },
            styleEvent(event)
          ]"
          @click="displayDetailsModal($event, event)"
        >
          <span class="tooltip" v-if="event.row.special ? false : true">{{
            event.text
          }}</span>
          <div
            class="scheduler-event-begin"
            :style="styleEventContentBegin(event)"
          >
            <div
              class="scheduler-event-begin-fill"
              :style="styleEventContentBegin(event)"
            >
              <div
                class="scheduler-event-begin-line"
                :style="styleEventContentBegin(event)"
              ></div>
            </div>
          </div>
          <div
            class="scheduler-event-middle"
            :class="{ 'scheduler-event-middle-special': event.row.special }"
            :style="styleEventContent(event)"
          >
            <slot v-bind:event="event"></slot>
            <div v-if="event.row.special" class="property-cell-info-occupancy">
              <img
                :src="favoriteImg(event.row.favorite)"
                class="favorite-heart"
                alt="blank-favorite"
              />
              <span :class="event.row.colorOccupancy" style="cursor: default">
                Two Week Occupancy: {{ event.row.occupancy }}%
              </span>
            </div>
          </div>
          <div class="scheduler-event-end" :style="styleEventContentEnd(event)">
            <v-popover
              :open="isOverlaping(event)"
              placement="top-end"
              boundariesElement="document.body"
              container=".scheduler-body-wrapper"
              class="overlaping-notif"
              :autoHide="false"
              v-if="isOverlaping(event)"
            >
              <template slot="popover">
                <img
                  id="overlap-notif"
                  style="cursor: pointer"
                  @click="showOverlapModal(event)"
                  alt="overlap-notif"
                  src="../../assets/overlap-notif.svg"
                />
              </template>
            </v-popover>
            <div
              class="scheduler-event-end-fill"
              :style="styleEventContentEnd(event)"
            >
              <div
                class="scheduler-event-end-line"
                :style="styleEventContentEnd(event)"
              ></div>
            </div>
          </div>
        </div>
        <div
          class="scheduler-cell"
          v-for="cell of cells"
          :key="cell.coordx"
          :style="styleCell(cell)"
        />
      </div>
      <div
        v-if="displayModal && popupEvent"
        class="floating-popup-container"
        :style="{
          position: 'absolute',
          zIndex: 15,
          left: popupX + 'px',
          top: popupY + 'px'
        }"
      >
        <Popup
          @showDeleteModal="showDeleteModal(popupEvent)"
          @showEditModal="showEditModal"
          :popupEvent="popupEvent"
          @hideDetailsModal="hideDetailsModal"
        />
      </div>
    </div>

    <div v-if="deleting">
      <delete-popup
        @confirm="deleteRental"
        @cancel="cancelDelete"
        :thingName="Rental"
      />
    </div>
    <div v-if="editing">
      <NewRentalScreen
        :selectedRental="selRental"
        @submitted="submitted"
        @cancel="cancelEdit"
      />
    </div>
    <div v-if="overlapModalVisible">
      <OverlapInfoModal
        @showEditModal="showEditModal"
        :overlapData="overlapData"
        @close="hideOverlapModal"
      />
    </div>
  </div>
</template>
<script>
const today = new Date()
const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
import plusGrey from '@/assets/plus-grey.svg'
import minusGrey from '@/assets/minus-grey.svg'
import { computePosition, flip, shift, offset } from '@floating-ui/dom'
import Popup from './Popup.vue'
import DeletePopup from '../../components/GenericDeletePopup.vue'
import RoomDetail from '../../screens/rooms/RoomDetail.vue'
import NewRentalScreen from '@/screens/rentals/NewRentalScreen.vue'
import OverlapInfoModal from './components/OverlapInfoModal.vue'
import moment from 'moment'

export default {
  components: {
    Popup,
    OverlapInfoModal,
    DeletePopup,
    NewRentalScreen,
    RoomDetail
  },
  props: {
    events: {
      type: Array,
      default() {
        return []
      }
    },
    allRooms: {
      type: Array,
      default() {
        return []
      }
    },
    columnTitle: String
  },
  data() {
    return {
      selRoom: null,
      smallDevice: false,
      year: today.getFullYear(),
      month: today.getMonth(),
      months: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ],
      selMonth: null,
      plusGrey,
      minusGrey,
      deleting: false,
      toDelete: {},
      selRental: [],
      editing: false,
      vw: 0,
      vh: 0,
      overlapData: [],
      overlapModalVisible: false,
      id: '',
      displayModal: false,
      popupEvent: null,
      popupX: 0,
      popupY: 0,
      idClose: '',
      isMonthChanged: false,
      daysInMonth: 31
    }
  },
  computed: {
    visibleEvents() {
      const currentRentals = this.events.filter(
        (event) =>
          !event.start.isAfter(this.selMonthEnd) &&
          !event.end.isBefore(this.selMonthStart)
      )
      return currentRentals
    },
    rows() {
      const rows = []
      const ids = []
      for (let event of this.visibleEvents) {
        if (ids.includes(event.row.room) == false) {
          rows.push({
            row: event.row,
            propertyName: event.propertyName,
            toggled: event.row.toggled,
            propertyUrl: `/properties/new/${event.row.propertyId}`
          })
          ids.push(event.row.room)
        }
      }

      return rows.sort((a, b) => {
        if (a.row.priority == b.row.priority) {
          return a.row.name.length - b.row.name.length
        } else {
          return a.row.priority - b.row.priority
        }
      })
    },
    dicRows() {
      const dictRows = {}
      let row_count = 0
      for (let i = 0; i < this.rows.length; i++) {
        if (
          this.rows[i].row.special ||
          this.rows[i].row.room in dictRows == false
        ) {
          dictRows[this.rows[i].row.room] = row_count
          row_count += 1
        }
        // dictRows.set(this.rows[i].id, i)
      }
      return dictRows
    },
    cells() {
      const cells = []
      const totalDays = this.isMonthChanged
        ? this.selMonthEnd.getDate()
        : this.daysInMonth
      for (let i = 0; i < totalDays; i++) {
        for (let j = 0; j < this.rows.length; j++) {
          cells.push({
            cordx: `${i},${j}`,
            x: i + 2,
            y: j + 2
          })
        }
      }
      return cells
    },
    selMonthStart() {
      if (this.isMonthChanged) {
        return new Date(this.year, this.month, 1)
      } else {
        // const currentDate = moment()
        //   .subtract(1, 'days')
        //   .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        //   .toDate()
        // return currentDate
        return this.days[0].date
      }
    },
    selMonthEnd() {
      if (this.isMonthChanged) {
        return new Date(this.year, this.month + 1, 0)
      } else {
        // const next30Days = moment()
        //   .add(this.daysInMonth, 'days')
        //   .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        //   .toDate()
        // return next30Days
        return this.days[this.days.length - 1].date
      }
    },
    days() {
      if (this.isMonthChanged) {
        return this.defaultDays
      }
      return this.loadDays
    },
    loadDays() {
      const currentDate = moment().subtract(1, 'days').set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      })
      const days = []
      for (let i = 0; i < this.daysInMonth; i++) {
        const dayOfMonth = currentDate.format('D') // Day of the month (e.g., '1', '2', '3')
        const dayName = currentDate.format('ddd')
        // Add the current date to the array
        days.push({
          ofWeek: dayOfMonth,
          ofMonth: dayName,
          gridPos: i + 1,
          date: currentDate.toDate(),
          keyIndex: i
        })
        // Move to the next day
        currentDate.add(1, 'days')
      }
      return days
    },
    defaultDays() {
      const daysInMonth = new Date(this.year, this.month + 1, 0).getDate()
      const days = []
      for (let i = 1; i <= daysInMonth; i++) {
        let date = new Date(this.year, this.month, i)
        days.push({
          ofWeek: weekDays[date.getDay()],
          ofMonth: i,
          gridPos: i,
          date: date,
          keyIndex: i
        })
      }
      return days
    }
  },
  methods: {
    favoriteImg(favorite) {
      if (favorite) {
        return require('@/assets/favorite.svg')
      }
      return require('@/assets/blank-favorite.svg')
    },
    getRoomId(id) {
      this.showRoomDetail(id)
    },
    showRoomDetail(id) {
      this.$modal.show('room-detail-modal')
      this.selRoom = id
    },
    generateId() {
      return (
        Math.random().toString(36).substring(2) +
        new Date().getTime().toString(36)
      )
    },
    resize() {
      this.vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      )
      this.vh = Math.max(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0
      )
      if (this.vw > 950) this.smallDevice = false
      else this.smallDevice = true
    },
    async styleSchedulerBody() {
      return {
        height: `${this.rows.length * 36}px`
      }
    },
    toggleEvents(row) {
      this.$emit('toggle', row)
      row.toggled = !row.toggled
      this.$forceUpdate()
    },
    styleEvent(event) {
      const daysInMonth = new Date(this.year, this.month + 1, 0).getDate()
      const daysFiltered = this.days.filter(
        (a) =>
          moment(a.date).isSameOrBefore(event.end) &&
          moment(a.date).isSameOrAfter(event.start)
      )

      if (daysFiltered.length === 0) {
        return
      }

      let columnStart = daysFiltered[0].gridPos + 1
      let columnEnd = daysFiltered[daysFiltered.length - 1].gridPos + 2
      if (this.isMonthChanged) {
        columnStart = 2
        columnEnd = event.end.date() + 2
        if (!event.start.isBefore(this.selMonthStart)) {
          columnStart = event.start.date() + 1
        }
        if (!event.end.isValid() || event.end.isAfter(this.selMonthEnd)) {
          columnEnd = daysInMonth + 2
        }
      }

      const style = {
        'grid-column-start': columnStart,
        'grid-row-start': this.dicRows[event.row.room] + 2,

        'grid-column-end': columnEnd,
        'grid-row-end': this.dicRows[event.row.room] + 3
      }
      if (style['grid-column-end'] <= style['grid-column-start']) {
        //special case of 1 night
        style['grid-column-end'] = style['grid-column-start'] + 2
      }

      return style
    },
    styleEventContent(event) {
      const style = {}
      style['width'] = `100%`
      style['border-right'] = 'none'
      style['border-left'] = 'none'
      return style
    },
    styleEventContentBegin(event) {
      const is_before_month = event.start.isBefore(this.selMonthStart)
      const style = {}
      if (is_before_month) {
        style['width'] = '0'
        style['height'] = '0'
        style['border'] = 'none'
      }
      return style
    },
    styleEventContentEnd(event) {
      const is_after_month =
        event.end.isAfter(this.selMonthEnd) || !event.end.isValid()
      const style = {}
      if (is_after_month) {
        style['width'] = '0'
        style['height'] = '0'
        style['border'] = 'none'
      }
      return style
    },
    styleCell(cell) {
      return {
        'grid-column-start': cell.x,
        'grid-column-end': cell.x + 1,
        'grid-row-start': cell.y,
        'grid-row-end': cell.y + 1
      }
    },
    changeMonth(monthIndex) {
      this.isMonthChanged = true
      this.selMonth = this.months[monthIndex]
      this.month = monthIndex
    },
    changeYear(delta) {
      this.year += delta
      this.$emit('loadRentals', this.year)
      this.changeMonth(0) // After change year, set Jan to load first
    },
    showDeleteModal(event) {
      this.deleting = true
      this.toDelete = {
        confirmationCode: event.confirmationCode
      }
    },
    showEditModal(payload) {
      this.selRental = payload
      this.editing = true
    },
    cancelDelete() {
      this.deleting = false
    },
    cancelEdit() {
      this.editing = false
    },
    submitted() {
      this.editing = false
      this.$emit('submitted', this.year)
    },
    deleteRental() {
      this.$emit('deleteRental', this.toDelete)
      this.deleting = false
    },
    success() {
      this.$emit('success')
      this.editing = false
    },
    lastBorder() {
      return 'border-bottom: 1px #E5E9ED solid;'
    },
    isOverlaping(event) {
      let realRentals = []
      //filters out the fake rentals so they dont cause conflicts when checking for overlap rentals
      realRentals = this.visibleEvents.filter(
        (event) => event.housemate.name !== 'fake'
      )

      if (realRentals != null) {
        for (let i = 0; i < realRentals.length; i++) {
          let current = realRentals[i]
          if (
            event.housemate.name.length > 0 &&
            current.housemate.name.length > 0 &&
            event.room.uuid === current.room.uuid &&
            event.id !== current.id &&
            event.end.isBetween(current.start, current.end)
          ) {
            if (event.end.diff(moment(this.selMonthEnd)) > 0) {
              return false
            }
            return true
          }
        }
      }
      return false
    },
    showOverlapModal(event) {
      if (this.visibleEvents != null) {
        let overlapEvent = this.visibleEvents.find(
          (a) =>
            a.room.uuid === event.room.uuid &&
            event.id !== a.id &&
            event.end.isBetween(a.start, a.end)
        )
        this.overlapData = []
        if (overlapEvent) {
          this.overlapData.push(event)
          this.overlapData.push(overlapEvent)
        }
        this.overlapModalVisible = true
      }
    },
    hideOverlapModal() {
      this.overlapModalVisible = false
    },

    async displayDetailsModal(e, event) {
      e.stopPropagation()
      if (!event.property) return

      this.id = event.id
      this.popupEvent = event
      this.displayModal = true

      await this.$nextTick()

      const reference = this.$el.querySelector(
        `.scheduler-event-container[data-id="${event.id}"]`
      )
      const floating = this.$el.querySelector('.floating-popup-container')
      const boundary = this.$el.querySelector('.scheduler-body-wrapper')

      if (!reference || !floating) return

      const { x, y } = await computePosition(reference, floating, {
        placement: 'bottom',
        strategy: 'absolute',
        middleware: [
          offset(4),
          flip({ boundary }),
          shift({ boundary, padding: { left: 174, right: 8 } })
        ]
      })

      this.popupX = x
      this.popupY = y
    },

    hideDetailsModal() {
      this.displayModal = false
      this.id = null
      this.popupEvent = null
    }
  },
  mounted() {
    this.selMonth = this.months[today.getMonth()]
    this.resize()
  },
  destroyed() {
    window.removeEventListener('resize', this.resize)
  },
  created() {
    window.addEventListener('resize', this.resize)
  }
}
</script>

<style scoped>
.property-cell-info-occupancy {
  position: sticky;
  right: 0;
}
.property-cell-info-occupancy > span {
  border: 1px solid;
  padding: 5px 10px;
  border-radius: 3px;
}

.property-cell-info-occupancy > span.red {
  background: rgba(204, 0, 0, 0.1);
  color: rgba(204, 0, 0, 1);
  border-color: rgba(204, 0, 0, 1);
}

.property-cell-info-occupancy > span.yellow {
  background: rgba(227, 151, 2, 0.1);
  color: rgba(227, 151, 2, 1);
  border-color: rgba(227, 151, 2, 1);
}

.property-cell-info-occupancy > span.green {
  background: rgba(24, 169, 0, 0.1);
  color: rgba(24, 169, 0, 1);
  border-color: rgba(24, 169, 0, 1);
}

.scheduler-container {
  font-family: Montserrat;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0px;
  padding: 16px 23px 16px 32px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.scheduler-header {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}
.scheduler-header-left {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  width: 512px;
  line-height: 41px;
}
.scheduler-year {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100px;
  font-size: 18px;
  font-weight: 900;
}
.scheduler-months {
  display: flex;
  flex-flow: row nowrap;
  cursor: pointer;
}
.scheduler-month {
  padding: 0 4px;
  border: solid #e5e9ed;
  border-width: 1px;
}
.scheduler-header-right {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 490px;
}
.scheduler-body-wrapper {
  margin-top: 23px;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: auto;
  position: relative;
}
.scheduler-body {
  display: grid;
  grid-template-columns: 166px repeat(31, minmax(36px, 1fr));
  gap: 0;
}
.scheduler-day-title {
  grid-row: 1 / 2;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-around;
  height: 56px;
  /* width: 36px; */
  margin: 0 0 0 -1;
}
.scheduler-column-title {
  grid-row: 1 / 2;
  line-height: 56px;
  min-width: 130px;
}
.scheduler-row-title {
  grid-column: 1 / 2;
  height: 36px;
  line-height: 36px;
  font-size: 9px;
}
.scheduler-row-title.last {
  border-bottom: 1px #e5e9ed solid;
}

.scheduler-row-title,
.scheduler-column-title {
  position: sticky;
  background-color: white;
  z-index: 11;
  left: 0;
  border: 1px #e5e9ed solid;
}

.scheduler-column-title {
  z-index: 12;
}

.scheduler-day-title {
  position: sticky;
  top: 0;
  z-index: 11;
  border: 1px #e5e9ed solid;
  background-color: white;
}

.scheduler-column-title {
  top: 0;
}

.scheduler-row-title,
.scheduler-column-title,
.scheduler-day-title {
  border-left: 1px #e5e9ed solid;
  border-top: 1px #e5e9ed solid;
}
.scheduler-row-special-title {
  background: #f2f4f6;
}
.scheduler-row-special-title-subcontainer {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  padding: 0 12% 0 12%;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 10px;
  color: #4a4a4a;
  max-height: 32px;
}
.scheduler-row-special-title-subcontainer img {
  cursor: pointer;
  margin-right: 12%;
}
.scheduler-row-special-title-subcontainer span {
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.scheduler-event-container {
  cursor: pointer;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
}
div.scheduler-event-middle-special {
  background: #f2f4f6;
  border: 1px solid #e5e9ed;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow: visible;
}
.scheduler-event-begin,
.scheduler-event-end {
  background: transparent;
  width: 36px;
  height: 36px;
}
.scheduler-event-begin {
  margin-top: 1px;
  border-bottom: 1px solid var(--rentalios-dark);
  padding-top: 0px;
}
.scheduler-event-begin-fill {
  width: 0;
  height: 0;
  border-bottom: 36px solid #ebf0e6;
  border-left: 36px solid transparent;
}
.scheduler-event-begin-line {
  width: 52px;
  height: 25px;
  border-bottom: 1px solid var(--rentalios-dark);
  transform: translate(-53px, -3px) rotate(-46deg);
}
.scheduler-event-middle {
  background-color: #ebf0e6;
  border: 1px solid var(--rentalios-dark);
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: var(--rentalios-dark);
  position: relative;
  z-index: 1;
  white-space: nowrap;
  overflow: hidden;
}
.scheduler-event-end {
  border-top: 1px solid var(--rentalios-dark);
}
.scheduler-event-end-fill {
  height: 0;
  width: 0;
  margin: 0;
  border-top: 36px solid #ebf0e6;
  border-right: 36px solid transparent;
}
.scheduler-event-end-line {
  width: 52px;
  height: 25px;
  border-bottom: 1px solid var(--rentalios-dark);
  transform: translate(-18px, -39px) rotate(-47deg);
  /* position: absolute; */
}
.scheduler-cell {
  border: 1px #e5e9ed solid;
}
.monthSelected {
  border: 1px solid #66b015;
  background: #66b015;
  color: white;
}
#leftArrow:hover,
#rightArrow:hover {
  cursor: pointer;
}
.scheduler-event-container {
  position: relative;
  overflow: visible;
}
.scheduler-event-container-fake {
  position: relative;
  overflow: hidden;
}
.scheduler-event-container .tooltip {
  transform: translate(-50%, -50%);
  left: 50%;
  visibility: hidden;
  position: absolute;
  z-index: 10;
  background: #66b015;
  box-shadow: 0px 4px 20px rgba(43, 45, 55, 0.1);
  border-radius: 4px;
  color: white;
  font-family: Montserrat;
  font-size: 10px;
  line-height: 10px;
  padding: 8px;
  top: 0;
}
.scheduler-event-container:hover .tooltip {
  visibility: visible;
}
.overlaping-notif {
  z-index: 2;
  position: absolute;
}

.scheduler-row-room-details {
  cursor: pointer;
  text-decoration: underline;
}
.favorite-heart {
  width: 18px;
  height: 18px;
  border: none;
  margin-right: 14px;
  cursor: default;
}
@media only screen and (max-width: 950px) {
  .scheduler-header {
    display: flex;
    flex-direction: column;
  }
  .scheduler-months {
    width: 100%;
  }
  .scheduler-month {
    flex: 1;
    border: solid 1px #e5e9ed;
    padding: unset;
  }
  .scheduler-header-left {
    order: 2;
    justify-content: normal;
    width: 100%;
  }
  .scheduler-header-right {
    margin: 5% 0;
    order: 1;
  }
  .scheduler-body-wrapper {
    margin-top: 16px;
  }
  .scheduler-container {
    padding: 16px;
  }
  .scheduler-year {
    display: none;
  }
  .scheduler-year-small-device {
    display: flex;
    flex-flow: row nowrap;
    width: 100px;
    font-size: 14px;
    font-weight: 900;
    gap: 12px;
    margin-right: 24px;
  }
  .scheduler-new-rental {
    z-index: 2;
  }

  .scheduler-header-right {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    width: 100%;
  }
}
</style>
